// extracted by mini-css-extract-plugin
module.exports = {"overlay":"src-components-DataProtectionOverlay-styles__overlay--22vIx","container":"src-components-DataProtectionOverlay-styles__container--2wOL9"};